import { render, staticRenderFns } from "./ProjectTaskManagement.vue?vue&type=template&id=e3dd42e8&"
import script from "./ProjectTaskManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports